import { styled, Text, TextAlignment } from '@volkswagen-onehub/components-core';
import { TextAppearance } from '@volkswagen-onehub/tokens';
import React from 'react';
import { COLOR_TOKEN, huchaRenovadoresLabelBackgroundColor } from '../../../../../helpers/color-tokens';

const StyledRenovadoresLabel = styled.div`
	position: absolute;
	transform: translate(-50%, -50%);
	top: 0;
	left: 50%;
	display: flex;
	align-items: center;
	width: 100%;
	max-width: max-content;
	min-width: auto;
	padding: 10px 16px;
	background: ${huchaRenovadoresLabelBackgroundColor};
	border-radius: 500px;
	text-align: center;

	@media (min-width: 1280px) {
		padding: 10px 34px;
	}

	// Texto
	& > div {
		color: ${COLOR_TOKEN.button.primary.default};
		line-height: 1.2;
		text-wrap: balance;
		word-break: keep-all;
	}
`;

export const HuchaRenovadoresLabel = ({ className }: { className?: string }): React.ReactElement => {
	return (
		<StyledRenovadoresLabel className={className}>
			<Text appearance={TextAppearance.copy200} textAlign={TextAlignment.center} bold>
				Todo este tiempo juntos se merece...
			</Text>
		</StyledRenovadoresLabel>
	);
};
